import { Schema as S } from 'effect';

import { Message } from './domain/message';
import { Email } from './primitive/email';

/**
 * Contact Us form data schema
 */
export const ContactUsFormSchema = S.Struct({
  email: Email,
  message: Message,
});

export type ContactUsFormData = S.Schema.Type<typeof ContactUsFormSchema>;

/**
 * API format for contact form submission
 */
export type ContactUsFormDataApiFormat = {
  email: string;
  message: string;
};
